import Feat from "../assets/BlogImages/Feat.webp";
import bg1 from "../assets/BackgroundImages/BG image 1.png";
import bg2 from "../assets/BackgroundImages/BG image 2.png";
import blogData from "../data/blogData";
import BlogCard from "../components/BlogCard";
import { useState, useMemo } from "react";
import { Link } from "react-router-dom";
import { FiMenu, FiX } from "react-icons/fi";

// Constants
const blogsPerPage = 3;
const categories = ["View all", "Design", "Product", "Software Engineering", "Customer Success"];

const Resources = () => {
  const [activeCategory, setActiveCategory] = useState("View all");
  const [currentPage, setCurrentPage] = useState(1);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Filter blogs by category
  const filteredBlogs = useMemo(() => (
    activeCategory === "View all"
      ? blogData
      : blogData.filter((blog) => blog.category === activeCategory)
  ), [activeCategory]);

  // Paginate blogs
  const paginatedBlogs = useMemo(() => (
    filteredBlogs.slice((currentPage - 1) * blogsPerPage, currentPage * blogsPerPage)
  ), [currentPage, filteredBlogs]);

  const totalPages = Math.ceil(filteredBlogs.length / blogsPerPage);

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setTimeout(() => setCurrentPage(page), 200);
    }
  };

  return (
    <div className=" text-white py-12 px-6">
       {/*Background Images*/}
      <div className=" -z-10 absolute h-full opacity-50 right-0">
        <img
          src={bg1}
          alt="bg"
          className="h-full w-auto object-contain"
        />  
      </div>

      <div className=" -z-10 absolute h-full opacity-50 left-0 translate-y-[150px]">
        <img
          src={bg2}
          alt="bg"
          className="h-full w-auto object-contain"
        />  
      </div>
      <div className="max-w-6xl mx-auto">
        <h2 className="text-xl text-gray-400">Our blog</h2>
        <h1 className="text-4xl font-bold pt-2 pb-5">Resources and insights</h1>
        <p className="text-gray-400 pt-2 pb-15">
          Your Source for Ideas, Insights & Everyday Inspiration.
        </p>

      <div className="relative w-full h-[550px] rounded-xl overflow-hidden shadow-lg bg-cover bg-center" style={{ backgroundImage: `url(${Feat})` }}>

</div>

<div className=" -z-10 absolute h-full opacity-50 right-0">
        <img
          src={bg1}
          alt="bg"
          className="h-full w-auto object-contain"
        />  
      </div>

      <div className=" -z-10 absolute h-full opacity-50 left-0">
        <img
          src={bg2}
          alt="bg"
          className="h-full w-auto object-contain"
        />  
      </div>
      </div>

      {/* Navbar */}
      <nav className="mt-12 bg-[#0B1E33] py-3 shadow-md relative">
        <div className="max-w-6xl mx-auto flex justify-between items-center px-4 md:px-0">
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="text-white focus:outline-none md:hidden"
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <FiX size={28} /> : <FiMenu size={28} />}
          </button>

          <ul className="hidden md:flex space-x-6">
            {categories.map((category) => (
              <li
                key={category}
                className={`cursor-pointer pb-1 transition-colors duration-200 ${
                  activeCategory === category
                    ? "text-white border-b-2 border-white"
                    : "text-gray-400"
                }`}
                onClick={() => {
                  setActiveCategory(category);
                  setCurrentPage(1);
                }}
              >
                {category}
              </li>
            ))}
          </ul>

          <select className="text-white bg-[#0B1E33] p-1 border border-gray-600 rounded hidden md:block">
            <option>Most recent</option>
          </select>
        </div>

        {/* Dropdown Menu for Small Screens */}
        {isMenuOpen && (
          <ul className="md:hidden bg-[#0B1E33] py-2 px-4">
            {categories.map((category) => (
              <li
                key={category}
                className={`cursor-pointer transition-colors duration-200 ${
                  activeCategory === category
                    ? "text-white border-b-2 border-white"
                    : "text-gray-400"
                }`}
                onClick={() => {
                  setActiveCategory(category);
                  setCurrentPage(1);
                  setIsMenuOpen(false);
                }}
              >
                {category}
              </li>
            ))}
          </ul>
        )}
      </nav>

      {/* Blog list section */}
      <div className="mt-12">
        <h2 className="text-3xl font-bold mb-6 text-center">Blog List</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {paginatedBlogs.map((blog) => (
            <BlogCard key={blog.id} blog={blog} />
          ))}
        </div>

        {/* Pagination Controls */}
        <div className="text-center mt-8 flex flex-wrap justify-center items-center gap-2 max-w-6xl mx-auto">
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            className={`px-4 py-2 rounded-lg w-full sm:w-auto ${
              currentPage === 1
                ? "bg-[#19BFB7] cursor-not-allowed"
                : "bg-[#0B1E33] hover:bg-[#102a45]"
            } transition text-white`}
            disabled={currentPage === 1}
            aria-label="Previous page"
          >
            Previous
          </button>

          <div className="flex flex-wrap justify-center gap-1">
            {Array.from({ length: totalPages }, (_, index) => (
              <button
                key={index + 1}
                onClick={() => handlePageChange(index + 1)}
                className={`px-3 py-2 mx-0.5 rounded-lg w-10 ${
                  currentPage === index + 1
                    ? "bg-[#102a45]"
                    : "bg-[#0B1E33] hover:bg-[#102a45]"
                } transition text-white`}
                aria-label={`Page ${index + 1}`}
              >
                {index + 1}
              </button>
            ))}
          </div>

          <button
            onClick={() => handlePageChange(currentPage + 1)}
            className={`px-4 py-2 rounded-lg w-full sm:w-auto ${
              currentPage === totalPages
                ? "bg-[#19BFB7] cursor-not-allowed"
                : "bg-[#0B1E33] hover:bg-[#102a45]"
            } transition text-white`}
            disabled={currentPage === totalPages}
            aria-label="Next page"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default Resources;
